module.exports = __webpack_public_path__ + "static/media/btn_apple_ch.cac98517.png";